import DataTableComponent from 'app/components/DataTableComponent';
import DropDownComponent from 'app/components/DropDownComponent';
import IOSSwitchComponent from 'app/components/IOSSwitchComponent';
import { VideoModal } from 'app/components/VideoModal';
import downloadSvg from 'assets/download.svg';
import EditIcon from 'assets/EditPen.svg';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';

import { Button, Fab, IconButton, Popover, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { GridColDef } from '@mui/x-data-grid';

import playButton from '../../../assets/videoPlay.png';
import { getIsSomeOneOnCurrentModule } from '../availabilitySaga/selectors';
import { actions as mediaActions } from '../mediaSaga/slice';
import { selectLoading as questionLoading } from '../Questions/selectors';
import { AddModal } from './components/AddModal';
import {
    selectCategories, selectCategory, selectPageNo, selectPageSize, selectQuestions,
    selectTotalQuestion
} from './selectors';
import { actions } from './slice';
import { useStyles } from './styles';

type Props = {};



const Questions = (props: Props) => {
    const dispatch = useDispatch();
    const questions = useSelector(selectQuestions);
    const pageSize = useSelector(selectPageSize)
    const pageNo = useSelector(selectPageNo)
    const totalQuestions = useSelector(selectTotalQuestion)

    const [openProfileModal, setOpenProfileModal] = useState(false)
    const [selectedProfileData, setSelectedProfileData] = useState({
        isVideoSelected: false,
        url: ''
    })

    const categories = useSelector(selectCategories);
    const category = useSelector(selectCategory);
    const isEditing = useSelector(getIsSomeOneOnCurrentModule);

    useEffect(() => {
        dispatch(actions.getPageNo(0));
        dispatch(actions.getQuestion());
        dispatch(actions.getCategory());
        return () => {
            dispatch(actions.getPageNo(0));
        };
    }, []);

    const [openModal, setOpenModal] = useState<{ isOpen: boolean, editData: any }>({ editData: null, isOpen: false });
    const onEdit = (data) => {
        setOpenModal({ isOpen: true, editData: data });
    }
    const [answeropenModal, setAnswerOpenModal] = useState(false);
    const [answerModalData, setAnswerModalData] = useState({
        questionId: '',
        videoUrl: ''
    })

    const [anchorEl, setAnchorEl] = useState<any>(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [deleteId, setDeleteId] = useState<string>('');

    const [anchor, setAnchor] = useState<any>(null);
    const handleDelete = () => {
        dispatch(actions.getDeleteQuestion(deleteId));
        setAnchor(null);
    };

    const handleDownload = (event, row) => {
        dispatch(mediaActions.getDownloadUrl({ key: row.video, name: row.name + "_" + (row.video.split("/")[(row.video.split("/").length - 1)]) }));
    };
    const handlePlayVideo = (event, row) => {
        if (row?.playList) {
            setOpenProfileModal(true)
            setSelectedProfileData({
                isVideoSelected: true,
                url: row?.playList
            })
            return
        }
        if(row.processStatus == 'PENDING') {
            toast.error('Video is still processing please check in some time')
        }
    };

    useEffect(() => {
        dispatch(actions.setAddMoreQuestions(false));
    }, [])

    const handleCloseEl = () => {
        setAnchor(null);
    };
    const PopOverDiv = () => {
        const open = Boolean(anchor);
        const id = open ? 'simple-popover' : undefined;
        return (
            <Popover
                id={id}
                open={open}
                anchorEl={anchor}
                onClose={handleCloseEl}
                sx={{
                    display: 'flex',
                    flex: 1,
                    padding: '2rem',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box
                    sx={{
                        boxShadow: 0,
                        p: 2,
                        borderRadius: 2,
                    }}
                >
                    <div>
                        <Typography>Delete This question ?</Typography>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Button
                                onClick={handleDelete}
                                sx={{
                                    backgroundColor: '#12BFE0',
                                    color: '#fff',
                                    borderRadius: '20px',
                                    margin: '10px 0px 0px 0px',
                                    '&:hover': {
                                        backgroundColor: '#12bfe0',
                                    },
                                }}
                            >
                                {'Delete'}
                            </Button>
                            <Button onClick={() => setAnchor(null)}>Close</Button>
                        </div>
                    </div>
                </Box>
                <ToastContainer />
            </Popover>
        );
    };
    const questionLoader = useSelector(questionLoading)

    const columns: GridColDef[] = [
        {
            field: 'date',
            headerName: 'Date',
        },
        {
            field: 'id', headerName: 'Question ID',
            width: 130
        },
        {
            field: 'name', headerName: 'Name', width: 220,
            renderCell: e => {
                return (
                    <div
                        style={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minHeight: '52px',
                            maxHeight: '52px',
                            lineHeight: '52px',
                            overflow: 'hidden',
                        }}
                    >
                        {e.row.name}
                    </div>
                );
            },
        },

        {
            field: 'body', sortable: false, headerName: 'Body', width: 230,
            renderCell: e => {
                return (
                    <div
                        style={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minHeight: '52px',
                            maxHeight: '52px',
                            lineHeight: '52px',
                            overflow: 'hidden',
                        }}
                    >
                        {e.row.body}
                    </div>
                );
            },
        },
        {
            field: 'video_length',
            sortable: false,
            headerName: 'Video Length',
            width: 110
        },
        { field: 'category', sortable: false, headerName: 'Category', width: 130 },
        {
            field: 'actions',
            headerName: 'Actions',
            sortable: false,
            width: 150,
            renderCell: e => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            flex: 0.7,
                            justifyContent: 'space-between',
                            alignItems:'center'
                        }}
                    >
                        <PopOverDiv />

                        <img
                            src={downloadSvg}
                            onClick={r => handleDownload(r, e.row)}
                            alt="downloadSvg"
                            className={styles.imgTagD}
                        />
                        <img
                            src={playButton}
                            onClick={r => handlePlayVideo(r, e.row)}
                            alt="playSvg"
                            className={styles.playTagD}
                        />
                        <IOSSwitchComponent isquestions={true} element={e.row} isEditing={isEditing} />
                        <IconButton onClick={() => onEdit(e.row)}> <img src={EditIcon} /> </IconButton>
                    </div>
                );
            },
        },
    ];

    const openAdd = () => setOpenModal({ isOpen: true, editData: null });

    const closeAdd = () => {
        setOpenModal({ isOpen: false, editData: null });
        dispatch(actions.clearFormData());
        dispatch(mediaActions.clearAddData());
    };

    const setCategoryId = id => {
        dispatch(actions.getCategoryId(id));
        dispatch(actions.setAddMoreQuestions(false))
        dispatch(actions.getQuestion());
    };

    const styles = useStyles();

    return (
        <div className={styles.mainDiv}>
            <div className={styles.headerDiv}>
                <DropDownComponent
                    array={[...categories, { id: "", name: "All" }]}
                    widthNo={'15rem'}
                    label="Category"
                    isCategory
                    setUser={setCategoryId}
                    user={category}
                />
                <div>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
                    </Popover>
                </div>
                <Fab
                    className={styles.fabBtn}
                    onClick={openAdd}
                    aria-label="add"
                >
                    <Typography sx={{ color: '#fff', fontSize: 32, fontWeight: '500' }}>
                        +
                    </Typography>
                </Fab>
            </div>
            <div className={styles.dataTable} style={{ position: 'relative' }}>

                <AddModal openModal={openModal.isOpen} editData={openModal.editData} closeAdd={closeAdd} />


                <div>
                    <VideoModal open={openProfileModal} onClose={() => { setOpenProfileModal(false) }} url={selectedProfileData?.url} />

                </div>


                <div className={styles.tableData}>
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataTableComponent
                            mainType={'QUESTIONS'}
                            updateAnswer={setAnswerModalData}
                            openAnswerModal={setAnswerOpenModal}
                            pageSize={pageSize}
                            page={pageNo}
                            rowCount={totalQuestions}
                            pageCount={questions.length}
                            onPageChange={(dummypageNo) => {
                                // dispatch(actions.setAddMoreQuestions(true))
                                dispatch(actions.setAddMoreQuestions(dummypageNo != 0 ? true : false))
                                dispatch(actions.getQuestion())
                            }}

                            rows={questions}
                            columns={columns}
                            header
                            loading={questionLoader}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default memo(Questions);
